const axios = require("axios");

export const getToken = () => {
    if (localStorage.getItem("keptLogged") == "true") {
        return localStorage.getItem("token") || null;
    }
    return sessionStorage.getItem("token") || null;
};

export const getMeetings = async (start ,end) => {
    const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `meetings?startDate=${start}&endDate=${end}`,
        {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        }
    );
    return response.data;
};

export const postMeeting = async (data) => {
    const response = await axios({
        method: "post",
        url: process.env.REACT_APP_API_BASE_URL + `meetings`,
        headers: {
            Authorization: "Bearer " + getToken(),
        },
        data:data
    });
    return response.data;
};


export const getMeeting = async (id) => {
    const response = await axios.get(
        process.env.REACT_APP_API_BASE_URL + `meetings/${id}`,
        {
            headers: {
                Authorization: "Bearer " + getToken(),
            },
        }
    );
    return response.data;
};

export const putMeeting = async (data,id) => {
    const response = await axios({
        method: "put",
        url: process.env.REACT_APP_API_BASE_URL + `meetings/${id}`,
        headers: {
            Authorization: "Bearer " + getToken(),
        },
        data: data
    });
    return response.data;
};


